import { BaseService } from "./BaseService";
import {
  MobileScreenSettingsScreenTypes,
  MobileScreenSettingsWithRelations,
  UpdateMobileScreenSettings,
} from "@/types/mobile-settings";

class MobileSettingsService extends BaseService {
  private basePath = "/mobile-settings";

  getSettings(
    hotelId: string,
    screenType: MobileScreenSettingsScreenTypes,
  ): Promise<MobileScreenSettingsWithRelations> {
    return this.get<MobileScreenSettingsWithRelations>(
      `${this.basePath}/${hotelId}`,
      { screenType },
    );
  }

  updateSettings(
    data: UpdateMobileScreenSettings,
  ): Promise<MobileScreenSettingsWithRelations> {
    return this.patch<MobileScreenSettingsWithRelations>(this.basePath, data);
  }

  createSettings(
    data: UpdateMobileScreenSettings,
  ): Promise<MobileScreenSettingsWithRelations> {
    return this.post<MobileScreenSettingsWithRelations>(this.basePath, data);
  }
}

export const mobileSettingsService = new MobileSettingsService();
